class ProductSpecifications {
  constructor(container) {
    this.container = container;
    this.tabButtons = container.querySelectorAll('.product-specifications__tab');
    this.tabPanes = container.querySelectorAll('.product-specifications__tab-pane');
    this.accordionItems = container.querySelectorAll('.product-specifications__accordion-item');
    this.accordionHeaders = container.querySelectorAll('.product-specifications__accordion-header');
    this.init();
  }

  init() {
    this.attachTabListeners();
    this.attachAccordionListeners();
    if (window.innerWidth <= 768) {
      const activeTab = this.container.querySelector('.product-specifications__tab--active');
      if (activeTab) {
        const targetTab = activeTab.getAttribute('data-tab');
        this.filterAccordionByTab(targetTab);
      }
    }
  }


  attachTabListeners() {
    this.tabButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        const targetTab = e.currentTarget.getAttribute('data-tab');
        this.switchTab(targetTab);
        if (window.innerWidth <= 768) {
          this.filterAccordionByTab(targetTab);
        }
      });
    });
  }

  switchTab(targetTab) {
    this.tabButtons.forEach(btn => btn.classList.remove('product-specifications__tab--active'));
    this.tabPanes.forEach(pane => pane.classList.remove('product-specifications__tab-pane--active'));
    const activeButton = this.container.querySelector(`[data-tab="${targetTab}"]`);
    const activePane = this.container.querySelector(`[data-tab-pane="${targetTab}"]`);

    if (activeButton) activeButton.classList.add('product-specifications__tab--active');
    if (activePane) activePane.classList.add('product-specifications__tab-pane--active');
  }

  filterAccordionByTab(targetTab) {
    const tabColumn = targetTab === 'tab-1' ? 'tab_1' : 'tab_2';
    
    this.accordionItems.forEach(item => {
      const itemTab = item.getAttribute('data-tab-column');
      
      if (itemTab === tabColumn) {
        item.style.display = 'block';
      } else {
        item.style.display = 'none';
        item.classList.remove('product-specifications__accordion-item--active');
      }
    });
  }

  attachAccordionListeners() {
    this.accordionHeaders.forEach(header => {
      header.addEventListener('click', (e) => {
        const accordionItem = e.currentTarget.closest('.product-specifications__accordion-item');
        this.toggleAccordion(accordionItem);
      });
    });
  }

  toggleAccordion(clickedItem) {
    const isActive = clickedItem.classList.contains('product-specifications__accordion-item--active');
    this.accordionItems.forEach(item => {
      item.classList.remove('product-specifications__accordion-item--active');
    });
    if (!isActive) {
      clickedItem.classList.add('product-specifications__accordion-item--active');
    }
  }
}

function initProductSpecifications() {
  const specifications = document.querySelectorAll('.product-specifications');

  specifications.forEach(spec => {
    if (!spec.hasAttribute('data-spec-initialized')) {
      new ProductSpecifications(spec);
      spec.setAttribute('data-spec-initialized', 'true');
    }
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initProductSpecifications);
} else {
  initProductSpecifications();
}

document.addEventListener('shopify:section:load', function(event) {
  const section = event.target;
  const spec = section.querySelector('.product-specifications');

  if (spec) {
    setTimeout(() => {
      new ProductSpecifications(spec);
      spec.setAttribute('data-spec-initialized', 'true');
    }, 100);
  }
});

document.addEventListener('shopify:section:unload', function(event) {
  const section = event.target;
  const spec = section.querySelector('.product-specifications');

  if (spec) {
    spec.removeAttribute('data-spec-initialized');
  }
});
